import React from 'react';
import { Container, Row, Col, CardBody, Card } from 'reactstrap';
import SwitchInput from '../../common/SwitchInput'; // Assuming the file location

const SwitchInputComponent = () => {
    return (
        <div className="page-content components">
            <Container>
                <Card>
                    <CardBody>
                        <h2 className="mb-4">Switch Input Showcase</h2>

                        {/* First Row - Default Switch Input */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <SwitchInput
                                    label="Default Switch"

                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<SwitchInput
    label="Default Switch"
/>
                                    `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Second Row - Required Switch Input */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <SwitchInput
                                    label="Required Switch"
                                    required={true}

                                    showHelp={true}
                                    helpText="This switch is required."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<SwitchInput
    label="Required Switch"
    required={true}
    showHelp={true}
    helpText="This switch is required."
/>
                                    `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Third Row - Custom Size Switch */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <SwitchInput
                                    label="Large Switch"
                                    size="large"

                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<SwitchInput
    label="Large Switch"
    size="large"
/>
                                    `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Fourth Row - Switch with Custom Colors */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <SwitchInput
                                    label="Colored Switch"
                                    switchColor="#28a745"
                                    switchOffColor="#dc3545"

                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<SwitchInput
    label="Colored Switch"
    switchColor="#28a745"
    switchOffColor="#dc3545"
/>
                                    `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Fifth Row - Non-Resizable Switch */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <SwitchInput
                                    label="Non-Resizable Switch"
                                    resizable={false}

                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<SwitchInput
    label="Non-Resizable Switch"
    resizable={false}
/>
                                    `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default SwitchInputComponent;
